import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0 1.5rem 0;
`;

export const FormContainer = styled.div`
  display: flex;
  width: 36rem;
  column-gap: 1rem;
  justify-content: end;
  align-items: flex-end;
  line-height: 1rem;

  & .input-wrapper {
    width: 23rem;
  }

  & button {
    width: 12rem;
    height: 2.8125rem;
  }
`;
